import { createSelector } from 'reselect';

const getDevice = (state) => {
    const {
        config: {
            deviceInteraction = {}
        } = {}
    } = state;

    return deviceInteraction;
};

export const getDeviceInteraction = createSelector(
    [getDevice],
    (
        deviceInteraction
    ) => (
        { deviceInteraction }
    )
);
